var render = function render(){var _vm=this,_c=_vm._self._c;return _c('materials-scanner',{ref:"materialsScanner",on:{"screen-closed":() => _vm.$emit('closed'),"open-loan":() => _vm.$emit('open-loan'),"find-by-tag":(tag, callback) => _vm.$emit('find-by-tag', tag, callback)}})
}
var staticRenderFns = []

export { render, staticRenderFns }